export interface JobStatusFields {
  is_filled?: boolean | null;
  is_archived?: boolean | null;
  post_removal_date?: string | null;
}

export interface JobStatus {
  canApply: boolean;
  statusLabel: string | null;
  tooltip: string | null;
}

export function getJobStatus(job: JobStatusFields | null | undefined): JobStatus {
  if (!job) return { canApply: false, statusLabel: null, tooltip: 'Job not found' };

  if (job.is_filled) {
    return { canApply: false, statusLabel: 'Filled', tooltip: 'This role has been filled' };
  }
  if (job.is_archived) {
    return { canApply: false, statusLabel: 'Archived', tooltip: 'This posting is no longer accepting applications' };
  }
  if (job.post_removal_date && new Date(job.post_removal_date) < new Date()) {
    return { canApply: false, statusLabel: 'Expired', tooltip: 'This posting has expired' };
  }

  return { canApply: true, statusLabel: null, tooltip: null };
}
